<template>

    <section class="row margin-b-100 order">

      <article class="wrap--xsm">

          <header class="header margin-b-50 padding-b-50 border-b">

              <h1>Betaling</h1>
              <p>Angive dine kreditkort oplysninger, til betaling af din bestilling.</p>

          </header>

          <section class="col-12 content margin-b-50 padding-b-50 border-b">

              <div id="payment-element" v-show="showPaymentForm">

              </div>

              <div class="col-12" v-show="!showPaymentForm">
                  <div class="spinner--dark center"></div>
              </div>

          </section>

          <section class="col-12 flex__space margin-b-75">

              <router-link :to="{name:'custom.order.approve'}">Tilbage</router-link>

              <button :class="{'disabled':!isValidated || isLoading}" class="btn--primary" href="#" @click.prevent="pay" :disabled="!isValidated || isLoading" dusk="approve-done">

              <span v-if="isLoading">

                  <i class="spinner--light" v-if="isLoading"></i>
                  Bearbejder

              </span>

              <span v-else>

                  Betal

              </span>

              </button>

          </section>

          <section class="col-12">

              <div class="card-list">

                  <img src="/images/visa-icon.svg" alt="Visa" />
                  <img src="/images/mastercard-icon.svg" alt="Mastercard" />
                  <img src="/images/american-express-icon.svg" alt="American Express" />
                  <a class="payment" tabindex="-1" title="Besøg Stripe" target="_blank" href="https://stripe.com/dk"><img src="/images/stripe-logo.svg" alt="Stripe Logo"></a>

              </div>

          </section>

          <section class="col-12 margin-t-25">

              <p><strong>OBS!</strong> Vi modtager <strong>IKKE alm. Dankort</strong> i shoppen.</p>

          </section>

        </article>

    </section>

</template>

<script>
    import {
        mapGetters
    } from "vuex";
    var stripe = Stripe(stripeKey);
    export default {
        name: "payment",
        data() {
            return {
                paymentIntent: null,
                elements: null,
                paymentElement: null,
                showPaymentForm: false,
                isLoading: false,
                isValidated: false,
            };
        },
        computed: {
            ...mapGetters({
                order: 'order',
                product: 'product',
                packaging_fee: 'packaging_fee',
                clientSecret: 'clientSecret',
                wantsNewsletter: 'wantsNewsletter',
            }),

        },
        methods: {
            pay() {
                if (!this.isValidated && this.isLoading) return;

                this.isLoading = true;

                stripe.confirmPayment({
                    elements: this.elements,
                    confirmParams: {
                        return_url: 'https://event.naesbyhovedskov.dk',
                        payment_method_data:{
                            billing_details:{
                                name: `${this.order.information.firstname} ${this.order.information.lastname}`,
                                address:{
                                    line1: `${this.order.information.address}`,
                                    postal_code: this.order.information.zipcode,
                                    city: this.order.information.city,
                                    country: 'DK'
                                },
                                email: this.order.information.email,
                                phone: this.order.information.phone,
                            }
                        }
                    },
                    redirect: 'if_required',
                }).then(result => {
                    if (result.error) {
                        this.$store.dispatch('setCardError', result.error.code);
                        this.$router.replace({
                            name: 'custom.order.failed'
                        });
                        this.isLoading = false;
                    } else {

                        let delivery = {
                            with_delivery: this.order.delivery.with_delivery,
                            deliver_at: this.order.delivery.deliver_at,
                            delivery_notes: this.order.delivery.delivery_notes,
                        };

                        if (this.order.delivery.with_delivery && String(this.order.delivery.information.address).length > 0) {
                            delivery.information = this.order.delivery.information;
                        }

                        if (this.order.delivery.hasOwnProperty('delivery_point')) {
                            delivery.delivery_point = this.order.delivery.delivery_point;
                        }

                        axios.post(`/api/public/custom/order`, {
                            details: this.order.details,
                            information: this.order.information,
                            delivery: delivery,
                            token: result.paymentIntent.id,
                            coupon: this.order.coupon,
                            newsletter: this.wantsNewsletter,
                            confirmation: true,
                        }).then(response => {
                            this.$store.dispatch('setInvoiceLink', response.data.data);
                            this.$store.dispatch('completedPayment');
                            this.$router.replace({
                                name: 'custom.order.complete'
                            });
                            this.isLoading = false;
                        }).catch(error => {
                            console.error(error);
                            this.$store.dispatch('setCardError', error.response.data.errors.code);
                            this.$router.replace({
                                name: 'custom.order.failed'
                            });
                            this.isLoading = false;
                        });
                    }
                });
            }
        },
        mounted() {
            const appearance = {
                theme: 'minimal',
                variables: {
                    fontFamily: "'Work Sans', sans-serif",
                    fontSize: '16px',
                    fontWeight: '300',
                    color: '#4a4847',
                    colorBackground: '#ece6df',
                    /* '::placeholder': {
                       color: "#bcb9b8",
                     }*/
                }
            };

            this.elements = stripe.elements({
                clientSecret: this.clientSecret,
                appearance
            });
            this.paymentElement = this.elements.create("payment");

            this.paymentElement.on('ready', () => {
                this.showPaymentForm = true;
            });

            this.paymentElement.on('change', event => {
                if (event.error || !event.complete) {
                    this.isValidated = false;
                } else if (event.complete) {
                    this.isValidated = true;
                }
            });

            this.paymentElement.mount("#payment-element");
        }
    }
</script>

<style scoped>

</style>
